(ns common.url
  (:require [clojure.string :as str]
            [common.util :as util]
            [goog.Uri :as Uri]))

(defn ^{:reference "https://github.com/google/closure-library/blob/master/closure/goog/uri/uri.js#L67"}
  current-uri
  "Returns an instance of `goog.Uri` with current location."
  []
  (goog.Uri. (.-location js/window)))

(defn ^{:reference "https://github.com/google/closure-library/blob/master/closure/goog/uri/uri.js#L1039"}
  map->query-data
  "Convert a map into QueryData instance."
  [m]
  {:pre [(map? m) (every? (some-fn string? int? boolean? nil? vector?) (vals m))]}
  (-> (util/filter-nils-map m)
      clj->js
      Uri/QueryData.createFromMap))

(defn parts->str
  "Converts url parts into single string.
   Double slashes are being removed.

   Example:

   ```clojure
   (parts->str [\"foo/\" \"bar\" \"/\" \"bazz\"])
   ;; => \"foo/bar/bazz\"
   ```"
  [parts]
  {:pre [(vector? parts) (every? (some-fn string? int?) parts)]}
  (->> parts
       (remove #(= "/" %))
       (map (comp #(str/replace % #"^/|/$" "") str))
       (str/join "/")))

(defn ^{:reference "https://github.com/google/closure-library/blob/master/closure/goog/uri/uri.js#L549"}
  parts->uri
  "Convert parts to instance of `goog.Uri`

   Example build with query:

   ```clojure
   (.setQuery (parts->uri [\"https://domain.com\"])
              (map->query-string {:foo \"bar\"}))
   ;; => \"https://domain.com?foo=bar\"
   ```"
  [parts]
  (goog.Uri/parse (parts->str parts)))

(defn query-string->map
  "Converts a query string into a map.

   Example:

   ```clojure
   (query-string->map \"foo=bar&quux=quuux\")
   ;; => {:foo \"bar\" :quux \"quuux\"}
   ```"
  [qs]
  (let [qd (Uri/QueryData. qs)
        k (map keyword (.getKeys qd))
        v (.getValues qd)]
    (zipmap k v)))

(defn map->query-string
  "Converts a map into a query-string where nil values are removed.

   Example:

   ```clojure
   (map->query-string {:foo \"my foo\" :bar \"bar\"})
   ;; => \"foo=my%20foo&bar=bar\"
   ```

   When option `encode` is set to false, the query-string is not URL encoded.

   Example:

   ```clojure
   (map->query-string {:foo \"my foo\"} {:encode false})
   ;; => \"foo=my foo\"
   ```
   "
  ([m] (map->query-string m {:encode true}))
  ([m {:keys [encode]}]
   {:pre [(map? m) (every? (some-fn string? int? boolean? nil? vector?) (vals m))]}
   (let [^goog.Uri/QueryData qd (map->query-data m)]
     (if encode
       (.toString qd)
       (.toDecodedString qd)))))

(defn construct
  "Convert parts and params into an url.

   Example:

   ```clojure
   (construct {:parts [\"https://example-domain.com\" \"sample\"]
               :params {:foo \"bar\"}})

   ;; => \"https://example-domain.com/sample?foo=bar\"
   ```"
  [{:keys [parts params] :or {params {}}}]
  (.toString (.setQuery ^goog.Uri/parse (parts->uri parts)
                        (map->query-string params {:encode false}))))

(defn query-parameters
  "Query paramters as map"
  []
  (query-string->map
   (.getQuery (current-uri))))
